// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3vte8","selected":"Chip_selected__2yCCD"};